import React from 'react';
import { Typography } from '@telus-uds/components-web';

import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import ErrorIcon from '../../../../../assets/images/icon_error_messages.gif';
import { sortedObjects } from '../../../../utils/utils';
import Label from './label';
import { _ } from 'core-js';

const ChannelField = ({
  label,
  errors,
  touched,
  values,
  setFieldValue,
  channels
}) => {
  const channelsList = sortedObjects(channels, 'description').map(
    ({ description, name }) => {
      return { id: name, label: description };
    }
  );

  return (
    <>
      <Label labelName={label} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${errors.channel && touched.channel ? 'error' : ''
          }`}
      >
        <Typeahead
          id="channelId"
          labelKey="label"
          options={channelsList}
          onChange={setFieldValue}
          placeholder="Select Channel"
          selected={values.channelId || []}
          clearButton
        />
        <>
          <div className="error_messages">
            <Typography variant={{ colour: 'error' }}>{errors.channel}</Typography>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

ChannelField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  channels: PropTypes.isRequired
};

export default ChannelField;
